/* eslint-disable */
import React from 'react';

const IconBolt = () => (
    <svg version="1.1"
         id="bolt"
         xmlns="http://www.w3.org/2000/svg"
         x="0px" y="0px"
         viewBox="0 0 512 512">
        <g>
            <path fill="currentColor" d="M421.091,205.814H295.034V0L90.909,306.188h126.056V512L421.091,205.814z M153.426,272.73l108.15-162.226v128.768h96.997
				l-108.15,162.225V272.73H153.426z"/>
        </g>
    </svg>

);

export default IconBolt;




